// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
// import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import LoadingSpinner from 'church-theme-library/components/LoadingSpinner/LoadingSpinner'
// import Link from 'church-theme-library/components/Link/Link'
// import PostSectionB from 'church-theme-library/components/PostSections/PostSectionB'
import MediaPlayer from 'church-theme-library/components/MediaPlayer/MediaPlayer'
import Image from 'church-theme-library/components/Image/Image'
import { get, getNextKeyInObject } from 'church-theme-library/utilities/objects'
// import { smoothScrollTo } from 'church-theme-library/utilities/scroll'

// Redux:
import { getVideosData } from 'church-theme-library/redux/actions/site'

class VideosPlaylistSelectedItemLayout extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		// window.scrollTo( 0, 0 )
		window.scrollTo( { top: 0, behavior: 'smooth' } )

		dispatch( getVideosData() )
	}

	componentDidUpdate( prevProps ) {
		const { selectedVideo } = this.props
		const videoID = get( [ 'match', 'params', 'video_id' ] )( this.props )
		const videoIDPrev = get( [ 'match', 'params', 'video_id' ] )( prevProps )

		if ( videoID != videoIDPrev ) {
			window.scrollTo( { top: 0, behavior: 'smooth' } )
		}
	}

	renderItem() {
		const { type, selectedVideo } = this.props

		if ( ! selectedVideo ) {
			return null
		}

		return (
			<div className="page-section page-section-resource_external_video is-odd">
				<div className="section-resource-external-video">
					<div className="section-media -style-inset">
						<div className="-inner">
							<div className="-media-wrap">
								<div className="-video">
									<MediaPlayer
										key={ selectedVideo.video_id }
										id={ selectedVideo.video_id }
										thumb_url={ get( ['thumbnail', 'url'] )( selectedVideo ) }
										service="youtube"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderNav = () => {
		const { nextVideo, nextVideoUrl, playlist, slugs, translate } = this.props

		if ( ! playlist && ! nextVideo ) {
			return null
		}

		const className = nextVideo ? 'section-video-playlist-nav -with-next' : 'section-video-playlist-nav'

		// Use <a> instead of <Link> as it will be handled by PageEvents.

		return (
			<div className="page-section page-section-video-playlist-nav is-even">
				<div className={ className }>
					<div className="-inner">
						{ playlist &&
							<a className="-list" href={ `/${slugs.videos}/${slugs.category}/${playlist.id}` }>
								<div className="-text">
									<p>{ translate( 'View playlist' ) }</p>
									<h5 dangerouslySetInnerHTML={ { __html: playlist.title } } />
								</div>

								{ playlist.thumbnail && playlist.thumbnail.url &&
									<div className="-image">
										<Image
											url={ playlist.thumbnail.url }
											alt={ playlist.title }
											width={ playlist.thumbnail.width }
											height={ playlist.thumbnail.height }
											aspectRatio="auto"
										/>
									</div>
								}
							</a>
						}

						{ nextVideo &&
							<a className="-next" href={ nextVideoUrl }>
								<div className="-text">
									<p>{ translate( 'Next' ) }</p>
									<h5 dangerouslySetInnerHTML={ { __html: nextVideo.title } } />
								</div>

								{ nextVideo.thumbnail && nextVideo.thumbnail.url &&
									<div className="-image">
										<Image
											url={ nextVideo.thumbnail.url }
											alt={ nextVideo.title }
											width={ nextVideo.thumbnail.width }
											height={ nextVideo.thumbnail.height }
											aspectRatio="auto"
										/>
									</div>
								}
							</a>
						}
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { type, playlist, selectedVideo, isLoading, loadingById, videosReceived } = this.props
		let showLoading = ! selectedVideo || ! videosReceived

		if ( isLoading ) {
			return null
		}

		return (
			<div>
				<div className="main-inner">
					{ showLoading &&
						<LoadingSpinner />
					||
						<div className="page-sections">
							{ this.renderItem() }
							{ this.renderNav() }
						</div>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	const slugs = state.site.slugs
	const slug = get( [ 'match', 'params', 'slug' ] )( ownProps )
	const videoID = get( [ 'match', 'params', 'video_id' ] )( ownProps )
	let playlist,
		recent,
		selectedVideo,
		playlistItems,
		nextVideoKey,
		nextVideo,
		nextVideoUrl

	if ( 'recent' == slug ) {
		recent = get( [ 'recent' ] )( state.site.videos )
		selectedVideo = get( [ `id_${videoID}` ] )( recent )
		nextVideoKey = getNextKeyInObject( `id_${videoID}`, recent )
		nextVideo = get( [ nextVideoKey ] )( recent )
		nextVideoUrl = nextVideo ? `/${slugs.videos}/${slugs.category}/recent/${nextVideo.video_id}` : ''
	} else {
		playlist = get( [ 'playlists', `id_${slug}` ] )( state.site.videos )
		playlistItems = get( [ 'items' ] )( playlist, {} )
		selectedVideo = get( [ `id_${videoID}` ] )( playlistItems )
		nextVideoKey = getNextKeyInObject( `id_${videoID}`, playlistItems )
		nextVideo = get( [ nextVideoKey ] )( playlistItems )
		nextVideoUrl = nextVideo ? `/${slugs.videos}/${slugs.category}/${playlist.id}/${nextVideo.video_id}` : ''
	}

	return {
		playlist,
		selectedVideo,
		nextVideo,
		nextVideoUrl,
		isLoading: state.page.isLoading,
		loadingById: state.page.loadingById,
		videos: state.site.videos,
		videosReceived: state.site.videosReceived,
		youtubeURL: state.site.youtubeURL,
		slugs
	}
}

export default localize(
	connect( mapStateToProps )( VideosPlaylistSelectedItemLayout )
)
